import React from 'react';

export const FormComponent = (requiredFields, inputFields, validateData) => {
    let allFieldsFilled = true;
    requiredFields.forEach(field => {
        if (typeof inputFields[field] === 'object' && field === 'datepicker') {
            if (inputFields[field] === '') {
                allFieldsFilled = false;
            }
        } else if (!inputFields[field] && typeof inputFields[field] === 'string' && inputFields[field].trim() === '') {     
            allFieldsFilled = false;
            const input = document.querySelector(`.AddressView .form-control[name="${field}"]`);
            input.classList.add('border-danger');
            const existingErrorIcon = input.parentNode.querySelector('.text-danger');
            if (!existingErrorIcon) {
                const newErrorIcon = document.createElement('span');
                newErrorIcon.classList.add('text-danger', 'la', 'la-exclamation-circle', 'error-icon');
                input.parentNode.appendChild(newErrorIcon);

                const tooltipText = document.createElement('span');
                tooltipText.innerText = findDisplayName(field, validateData);
                tooltipText.classList.add('badge', 'badge-danger', 'error-icon-text');
                newErrorIcon.appendChild(tooltipText);

                input.addEventListener('input', () => {
                    if (input.value.trim() !== '') {
                        const errorIcon = input.parentNode.querySelector('.text-danger');
                        if (errorIcon) {
                            errorIcon.parentNode.removeChild(errorIcon);
                        }
                    }
                });
            }
        } else {
          //  console.log('form submited')
        }
    });

    if (!allFieldsFilled) {
        console.log('Some required fields are empty!', allFieldsFilled);
    }

    return allFieldsFilled;
};

function findDisplayName(inputName, validateData) {
    const foundItem = validateData.find(item => item.inputName === inputName);
    return foundItem ? foundItem.displayName : null;
}
